"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rightNormal = exports.rightHover = exports.leftNormal = exports.leftHover = exports.leftDisable = void 0;

var tslib_1 = require("tslib");

var ic_arrow_left_md_gray_300_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrow-left-md-gray-300.svg"));

exports.leftDisable = ic_arrow_left_md_gray_300_svg_1.default;

var ic_arrow_left_md_gray_700_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrow-left-md-gray-700.svg"));

exports.leftHover = ic_arrow_left_md_gray_700_svg_1.default;

var ic_arrow_left_md_gray_500_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrow-left-md-gray-500.svg"));

exports.leftNormal = ic_arrow_left_md_gray_500_svg_1.default;

var ic_arrow_right_md_gray_700_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrow-right-md-gray-700.svg"));

exports.rightHover = ic_arrow_right_md_gray_700_svg_1.default;

var ic_arrow_right_md_gray_500_svg_1 = tslib_1.__importDefault(require("../../assets/ic-arrow-right-md-gray-500.svg"));

exports.rightNormal = ic_arrow_right_md_gray_500_svg_1.default;